import { useCallback } from 'react';
import EvalReport from '../../view_web_eval/report/EvalReport';
import { firestoreLegacyReportApi } from '../../view_web_eval/report/reportApi';
import { EVAL_AREAS } from '../../view_web_eval/report/reportCodes';
import {
  resolveLegacyCaseNumber,
  resolveLegacyClient,
  scoreLegacyEvalCodes,
} from './legacyEvalScorer';

/**
 * Legacy eval area wrapper. Routes scoring through the legacy scorer only
 * (RTDB selectedCase + master chart compare). Shared CMS + generate +
 * history live in EvalReport. Do not call the cloud scorer from here.
 */
export default function LegacyEvalReport({
  selectedCase,
  master,
  selectedEvalId,
  rawData,
  normalizedData,
  api = firestoreLegacyReportApi,
  claims,
}) {
  const client = resolveLegacyClient(selectedCase);
  const scoreCodes = useCallback(
    (overrides) => scoreLegacyEvalCodes({
      selectedCase,
      master,
      rawData,
      normalizedData,
      overrides,
    }),
    [selectedCase, master, rawData, normalizedData]
  );

  return (
    <EvalReport
      allowSaOverrides
      api={api}
      area={EVAL_AREAS.LEGACY}
      caseNumber={resolveLegacyCaseNumber(selectedCase)}
      claims={claims}
      client={client}
      description={(
        <p>
          DA is the Image bar vs the plotted control bar ± error bar from the same
          rows EvalGraphs already charts (Normalized tab by default:
          client/AVG vs 1 ± <code className="rounded bg-gray-100 px-1">STD_DEV</code>;
          Raw tab: client UVF vs <code className="rounded bg-gray-100 px-1">AVG</code> ±
          AVG×STD_DEV). This is not the cloud Firestore
          <code className="rounded bg-gray-100 px-1">sd</code> / 1±sd adapter.
          Legacy self-report SA is only used when a 0–3 field is present; otherwise override SA here.
          HS, CS, and D are stubs (default 0) so template keys can be formed.
        </p>
      )}
      evaluationId={selectedEvalId}
      organizationId={client.organization_id}
      scoreCodes={scoreCodes}
      title="Legacy Eval Report"
    />
  );
}
